export const next = {
  staticPropsRevalidateSeconds: 7 * 24 * 60 * 60 // 1 week
}